export enum Category {
  推荐 = '809',
  人物立绘 = '1',
  辅助立绘 = '70',
  背景 = '72',
  CG = '73',
  UI = '76',
  音乐 = '74',
  音效 = '75',
  特效 = '798',
  偶像区 = '592',
  以爱之名 = '609',
}
